module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"Edit event type","delete":"Delete event type","positive":"Positive influence","negative":"Negative influence"},"es":{"edit":"Editar tipo de evento","delete":"Eliminar tipo de evento","positive":"Influencia positiva","negative":"Influencia negativa"}}')
  delete Component.options._Ctor
}
